// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"138":"13175c13","492":"19d9f928","633":"13175c13"}[chunkId] + ".chunk.css";
};